import { render, staticRenderFns } from "./StudioProjectList.vue?vue&type=template&id=373ec476&scoped=true&"
import script from "./StudioProjectList.vue?vue&type=script&lang=js&"
export * from "./StudioProjectList.vue?vue&type=script&lang=js&"
import style0 from "./StudioProjectList.vue?vue&type=style&index=0&id=373ec476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ec476",
  null
  
)

export default component.exports